import React, { useMemo } from 'react';
import Image from 'next/legacy/image';

import arrowLeft from '../../public/images/arrow-left.svg';
import { SavedSearches } from 'apolloClient/types/Searches';
import { generateSearchPageLink } from 'components/Search/utils/searchUtils';
import { filterValuesFromDb } from './utils/filterValuesFromDb';
import { defaultFilterValues } from 'components/UnitsFilters/constants';

const SavedSearchLink = ({ param }: { param: SavedSearches }) => {
  const viewLink = useMemo(
    () =>
      generateSearchPageLink(filterValuesFromDb(param), defaultFilterValues),
    [param]
  );
  return (
    <a
      target="_blank"
      rel="nofollow noopener noreferrer"
      href={viewLink}
      className="flex items-center ml-4 uppercase border-b-2 cursor-pointer border-gold-dark md:mt-8 md:mb-10 lg:my-6 w-max md:ml-0"
    >
      <div className="w-5 h-4">
        <Image src={arrowLeft} alt="view" width={15} />
      </div>
      <span className="whitespace-nowrap">View</span>
    </a>
  );
};

export default SavedSearchLink;
